import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';

const liveOrderStreamWidgetHeaderWrapper = {
    "fontFamily": "GraphikRegular",
};

@inject('RootStore')
@observer
export default class LiveOrderStreamWidgetHeader extends Component {
    render() {
        const {styleStore, configStore} = this.props.RootStore
        const currentStylesDict = styleStore.currentStylesDict;
        const boxedOrderReadyStyle = {
            borderRadius: currentStylesDict.orderStreamWidgetKeyRadius,
            backgroundColor: currentStylesDict.ready
        };
        const boxedOrderPreparingStyle = {
            borderRadius: currentStylesDict.orderStreamWidgetKeyRadius,
            backgroundColor: currentStylesDict.preparing
        };
        const boxedOrderQueuedStyle = {
            borderRadius: currentStylesDict.orderStreamWidgetKeyRadius,
            backgroundColor: currentStylesDict.queued
        };
        const liveOrderStreamHeaderStyle = {
            fontSize: "1.5em",
            color: currentStylesDict.orderStreamWidgetFontColor
        };

        return (
            <Flexbox flexGrow={1} flexDirection="column" style={liveOrderStreamWidgetHeaderWrapper}>
                <Flexbox style={liveOrderStreamHeaderStyle} flexDirection="row">
                    <Flexbox height="100%" width="64%" flexGrow={1} flexDirection="row"
                             justifyContent="space-between" alignItems="center">
                        <Flexbox width="4.5%" height="100%" style={boxedOrderReadyStyle}></Flexbox>
                        <Flexbox width="1%"></Flexbox>
                        <Flexbox flexGrow={1}>
                            Ready for Pickup
                        </Flexbox>
                        <Flexbox width="1.5%"></Flexbox>
                        <Flexbox width="4.5%" height="100%" style={boxedOrderPreparingStyle}></Flexbox>
                        <Flexbox width="1%"></Flexbox>
                        <Flexbox flexGrow={1}>
                            Preparing
                        </Flexbox>
                        <Flexbox width="1.5%"></Flexbox>
                        <Flexbox width="4.5%" height="100%"style={boxedOrderQueuedStyle}></Flexbox>
                        <Flexbox width="1%"></Flexbox>
                        <Flexbox flexGrow={1}>
                            Queued
                        </Flexbox>
                    </Flexbox>
                    <Flexbox flexGrow={1} height="100%"></Flexbox>
                    <Flexbox flexGrow={1} height="100%" alignItems="center" justifyContent="flex-end">
                        {configStore.currentDateTime}
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/order_stream_widget/live_order_stream_widget_header.jsx